import createLucideIcon from '../createLucideIcon';
import { IconNode } from '../types';

export const __iconNode: IconNode = [
  [
    'path',
    {
      d: 'M20 9.807V6a1 1 0 00-1-1c-2 0-4.49-1.19-6.24-2.72a1.17 1.17 0 00-1.52 0C9.5 3.8 7 5 5 5a1 1 0 00-1 1v7c0 3.88 2.107 6.254 5 7.796',
      key: '1gl1o4',
    },
  ],
  ['path', { d: 'M19 17v-2a2 2 0 00-4 0v2', key: 'uefur0' }],
  ['rect', { x: '13', y: '17', width: '8', height: '5', rx: '1', key: '2y8vuh' }],
];

/**
 * @component @name ShieldLock
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMjAgOS44MDdWNmExIDEgMCAwMC0xLTFjLTIgMC00LjQ5LTEuMTktNi4yNC0yLjcyYTEuMTcgMS4xNyAwIDAwLTEuNTIgMEM5LjUgMy44IDcgNSA1IDVhMSAxIDAgMDAtMSAxdjdjMCAzLjg4IDIuMTA3IDYuMjU0IDUgNy43OTYiIC8+CiAgPHBhdGggZD0iTTE5IDE3di0yYTIgMiAwIDAwLTQgMHYyIiAvPgogIDxyZWN0IHg9IjEzIiB5PSIxNyIgd2lkdGg9IjgiIGhlaWdodD0iNSIgcng9IjEiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/shield-lock
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ShieldLock = createLucideIcon('shield-lock', __iconNode);

export default ShieldLock;
